<template>
  <a
    v-if="url"
    :class="[
      'button-primary',
      { black: props.isBlack },
      { image: props.onImage },
    ]"
    :style="style"
    :href="url"
    target="_blank"
    @click="pushEvent"
  >
    <icon
      v-if="iconBefore"
      class="button-icon"
      :data="iconBefore"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
    <span>{{ label }}</span>
    <icon
      v-if="iconAfter"
      class="button-icon"
      :data="iconAfter"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
  </a>

  <button
    v-else
    :class="[
      'button-primary',
      { black: props.isBlack },
      { image: props.onImage },
    ]"
    :style="styles"
    @click="$emit('onClick')"
  >
    <icon
      v-if="iconBefore"
      class="button-icon"
      :data="iconBefore"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
    <span>{{ label }}</span>
    <icon
      v-if="iconAfter"
      class="button-icon"
      :data="iconAfter"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
  </button>
</template>

<script setup>
import { pushData } from "@/utilities/analytics-functions.js";

const props = defineProps({
  label: String,
  url: String,
  isBlack: Boolean,
  iconBefore: Object || undefined,
  iconAfter: Object || undefined,
  onImage: Boolean,
  styles: Object,
  componentTitle: { type: String, default: "", required: false },
  componentType: { type: String, default: "", required: false },
});

function pushEvent() {
  if (props.url && props.url.includes(".pdf")) {
    pushData({
      event: "fileDownload",
      eventType: "pdf",
      componentType: props.componentType,
      componentTitle: props.componentTitle,
      componentLink: props.url,
      componentLinkText: props.label,
    });
  }
}
</script>

<style lang="scss" scoped>
.button-primary {
  @include overlay-m;

  max-height: calc(toRem(18) + calc(0.75rem * 2));

  border-radius: 59px;
  padding: 0.75rem toRem(24);
  color: var(--color-white);
  border: 2px solid var(--color-white);
  width: fit-content;
  // transition: border 0.3s, color 0.3s, background-color 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  --icon-color: var(--color-white);

  // svg {
  //   transition: stroke 0.3s, fill 0.3s;

  //   path {
  //     transition: stroke 0.3s, fill 0.3s;
  //   }
  // }

  &.black {
    color: var(--color-black);
    border: 2px solid var(--color-black);
    --icon-color: var(--color-black);
  }

  &.image {
    background-color: var(--color-white-15);
  }

  &:hover:not(:disabled) {
    --color-hover: #dbedff;
    --border-hover: var(--brand-stronger);

    &.black {
      --color-hover: #052e55;
      --border-hover: var(--brand-weaker);
    }

    --icon-color: var(--color-hover);
    border: 2px solid var(--border-hover);
    color: var(--color-hover);
  }

  .mobile & {
    padding: 0.5rem 1.5rem;
    max-height: none;
  }
}
</style>
